var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledTopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13C26.0938 13 27 13.9062 27 15V27C27 28.125 26.0938 29 25 29H17C15.875 29 15 28.125 15 27V15C15 13.9062 15.875 13 17 13H25ZM21.5 24C21.75 24 22 23.7812 22 23.5C22 23.25 21.75 23 21.5 23H17.5C17.2188 23 17 23.25 17 23.5C17 23.7812 17.2188 24 17.5 24H21.5ZM24.5 21C24.75 21 25 20.7812 25 20.5C25 20.25 24.75 20 24.5 20H17.5C17.2188 20 17 20.25 17 20.5C17 20.7812 17.2188 21 17.5 21H24.5ZM24.5 18C24.75 18 25 17.7812 25 17.5C25 17.25 24.75 17 24.5 17H17.5C17.2188 17 17 17.25 17 17.5C17 17.7812 17.2188 18 17.5 18H24.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledTopic);
export default __webpack_public_path__ + "static/media/filledTopic.f5c736e69f1223fbc4499290fbffdc1b.svg";
export { ForwardRef as ReactComponent };